import {createFileRoute} from '@tanstack/react-router'
import AmericanosView from "../../../americanos/AmericanosView.tsx";

export const Route = createFileRoute('/_app/americanos/$americano_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <AmericanosView />
}
